import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { FadeUp } from "../components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShowSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setState("failed");
      return;
    }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/show/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch {
        /* keep polling */
      }
      tries += 1;
      if (tries < 15) setTimeout(poll, 2000);
      else setState("failed");
    };
    poll();
  }, [sessionId]);

  return (
    <main data-testid="show-success-page" className="flex min-h-svh items-center justify-center px-4">
      <FadeUp>
        <div className="clip-corner max-w-lg border border-zinc-800 bg-carbon p-10 text-center">
          {state === "checking" && (
            <div data-testid="show-success-checking">
              <Loader2 size={44} className="mx-auto animate-spin text-[#16A34A] mb-6" />
              <h1 className="font-display text-4xl font-black uppercase italic text-white">Confirming payment...</h1>
              <p className="mt-3 text-sm text-zinc-400">Hold tight while Stripe confirms your entry.</p>
            </div>
          )}
          {state === "paid" && (
            <div data-testid="show-success-confirmed">
              <CheckCircle2 size={44} className="mx-auto text-[#16A34A] mb-6" />
              <h1 className="font-display text-4xl sm:text-5xl font-black uppercase italic text-white">
                You're <span className="text-[#16A34A] glow-green">in.</span>
              </h1>
              <p className="mt-4 text-sm sm:text-base leading-relaxed text-zinc-400">
                Your truck is registered for the ETN Customz Toy Bash — December 5, 2026, 10 AM to 6 PM at 160 Raceway Dr, Maynardville, TN. The shop has your entry and will reach out with details.
              </p>
              <Link
                to="/"
                data-testid="show-success-home-link"
                className="clip-badge mt-8 inline-flex items-center gap-2 bg-[#16A34A] px-8 py-3.5 font-display text-lg font-bold uppercase text-black transition-colors hover:bg-[#22C55E]"
              >
                Back to the site
              </Link>
            </div>
          )}
          {state === "failed" && (
            <div data-testid="show-success-failed">
              <XCircle size={44} className="mx-auto text-[#DC2626] mb-6" />
              <h1 className="font-display text-4xl font-black uppercase italic text-white">Couldn't confirm</h1>
              <p className="mt-3 text-sm text-zinc-400">
                If your card was charged, your entry still counts — call or text 865-258-9267 and we'll confirm your spot.
              </p>
              <Link
                to="/show"
                data-testid="show-success-retry-link"
                className="clip-badge mt-8 inline-flex items-center gap-2 border border-zinc-600 px-8 py-3.5 font-display text-lg font-bold uppercase text-white transition-colors hover:border-[#16A34A] hover:text-[#16A34A]"
              >
                Back to the show page
              </Link>
            </div>
          )}
        </div>
      </FadeUp>
    </main>
  );
}
